import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { patchTheme } from '@/services/user';
import { useTheme } from '@/providers/theme-provider';
import { useAuthenticationDispatch } from '@/hooks/use-authentication';
import { errorHandler } from '@/lib/utils';
/**
 * Apply a theme choice locally for instant UI feedback, then persist it to
 * the backend so the choice follows the user across devices. On success we
 * dispatch UPDATE_USER so any in-tree subscribers (e.g. the Profile select)
 * stay in lockstep.
 */
export function useThemeMutation() {
    const { setTheme } = useTheme();
    const dispatch = useAuthenticationDispatch();
    const { mutate, isPending } = useMutation({
        mutationFn: patchTheme,
        onSuccess: (data) => {
            toast.success(data.message);
            dispatch({ type: 'UPDATE_USER', user: data.user });
        },
        onError: errorHandler,
    });
    const updateTheme = (next) => {
        setTheme(next);
        mutate({ theme: next });
    };
    return { updateTheme, isPending };
}
